import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const ManagementCommittee = () => {
       useEffect(() => {
        document.title = 'Management Committee -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  About Us  </li> 
     <li>Management Committee </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Management Committee  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
       <iframe src='https://webapi.entab.info/api/image/STPSFH/public/pdf/MANAGEMENT-COMMITTEE.pdf#toolbar=0' width="100%" height="800" title="Transfer Certificate Sample" rel="noreferrer"></iframe>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default ManagementCommittee
